module.exports = __webpack_public_path__ + "img/160909.4b40ce52.png";